import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";

function RadarChart() {
  const { options, series } = useMemo(
    () => ({
      options: {
        colors: [colors.ReactifyChartColor1],
        labels: ["January", "February", "March", "April", "May", "June"],
        title: {
          text: "Basic Radar Chart"
        }
      },
      series: [
        {
          name: "Series 1",
          data: [80, 50, 30, 40, 100, 20]
        }
      ]
    }),
    []
  );

  return (
    <Chart options={options} series={series} type="radar" width="100%" />
  );
}

export default RadarChart;
